import Vue from "vue";
import Router from "vue-router";
import routes from './routes';
// import Monitoring from "@/views/monitoring/Monitoring";
import AboutView from "@/views/AboutView";
import Login from "@/views/auth/Login";
import LoginForm from "@/components/auth/LoginForm";
import ForgotPassword from "@/components/auth/ForgotPassword";
import ResetPassword from "@/components/auth/ResetPassword";
import ResponseError from "@/views/error/ResponseError";
import Management from "@/views/modules/Management.vue";
import UserConfig from "@/views/userconfig/UserConfiguration.vue";
import HistoricalData from "@/views/historical/HistoricalData";
const LightningHistory = () => import('@/views/historical/LightningHistory.vue');

// Lazy loading
const Monitoring = () => import('@/views/monitoring/Monitoring.vue');

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.VUE_APP_PUBLIC_PATH || '/',
  routes: [
    {
      path: "/",
      redirect: routes.monitoring.path,
    },
    {
      path: "*",
      redirect: routes.responseError.path,
    },
    {
      path: routes.login.path,
      component: Login,
      children: [
        {
          ...routes.login.children.loginForm,
          component: LoginForm,
        },
        {
          ...routes.login.children.forgotPassword,
          component: ForgotPassword,
        },
        {
          ...routes.login.children.resetPassword,
          component: ResetPassword,
        },
      ],
    },
    {
      path: routes.monitoring.path,
      name: routes.monitoring.name,
      component: Monitoring,
      meta: {
        requiresAuth: true,
        authorize: routes.monitoring.authorize
      }
    },
    {
      path: routes.historical.path,
      name: routes.historical.name,
      component: HistoricalData,
      meta: {
        requiresAuth: true,
        authorize: routes.historical.authorize
      }
    },
    {
      path: routes.lightningHistory.path,
      name: routes.lightningHistory.name,
      component: LightningHistory,
      meta: {
        requiresAuth: true,
        authorize: routes.lightningHistory.authorize
      }
    },
    {
      path: routes.aboutView.path,
      name: routes.aboutView.name,
      component: AboutView,
      meta: {
        requiresAuth: true,
        authorize: routes.aboutView.authorize,
      },
    },
    {
      ...routes.responseError,
      component: ResponseError,
      meta: { bothGuestAuth: true },
      props: true,
    },
    {
      path: routes.management.path,
      name: routes.management.name,
      component: Management,
      meta: {
        requiresAuth: true,
        authorize: routes.management.authorize,
      },
    },
    {
      path: routes.userConfig.path,
      name: routes.userConfig.name,
      component: UserConfig,
      meta: {
        requiresAuth: true,
        authorize: routes.userConfig.authorize,
      },
    },
  ],
});
